import { Vehicle } from '../../../../types/vehicle';
import NumberFormat from 'react-number-format';
import { useAdminOfferAuction, useCustomerHoverStateHandlers } from '../hooks';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { HoverInfoTooltip } from './HoverInfo';
import { useMemo, useRef } from 'react';
import { useIsTextOverflown } from '../../../../hooks';
import { User } from 'types/user';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0px;
  font-weight: 500;
`;

const Label = styled.span`
  color: #757575;
  font-family: Roboto;
  font-size: 14px;
  font-weight: 400;
  max-width: 66px;
  cursor: pointer;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  margin-top: 8px;
`;

type Props = {
  vehicle: Vehicle;
};

const companyToLabel: Record<string, string> = {
  acv: 'ACV',
  other: 'Other',
  open_lane: 'OL'
};

export const AdminAAProxyOffers = ({ vehicle }: Props) => {
  const offerAuction = useAdminOfferAuction(vehicle.id);
  const proxyOfferBid = offerAuction?.offerProxyBid;

  return (
    <AdminProxyOffers
      amount={proxyOfferBid?.amount}
      auctionId={vehicle.auction_id}
      bidder={proxyOfferBid?.bidder || {}}
    />
  );
};

export const AdminAlternativeProxyOffers = ({ vehicle }: Props) => {
  const proxyOfferBid = vehicle.top_alternative_bid_offer;

  return (
    <AdminProxyOffers
      amount={proxyOfferBid?.amount}
      auctionId={vehicle.auction_id}
      bidder={proxyOfferBid?.bidder || {}}
    />
  );
};

type GeneralProps = {
  amount?: number;
  auctionId: number;
  bidder: User;
};

export const AdminProxyOffers = ({ amount, auctionId, bidder }: GeneralProps) => {
  const { isOpen, handleClose, handleOpen } = useCustomerHoverStateHandlers();

  const ref = useRef<HTMLSpanElement>(null);
  const isTextOverflown = useIsTextOverflown(ref);

  const label = useMemo(() => {
    if (bidder.is_bot) {
      return `${companyToLabel[bidder.company_name]} - ${bidder.dealership_name}`;
    }

    return bidder.dealership_name || '';
  }, [bidder]);

  return (
    <Wrapper>
      <NumberFormat displayType="text" prefix="$" value={amount ?? 0} thousandSeparator />
      {amount && (
        <HoverInfoTooltip
          anchorEl={ref.current}
          initialPage={`/admin/auctions/${auctionId}`}
          isPopoverOpened={isOpen}
          closeTooltip={handleClose}
          showTooltip={isTextOverflown}
          userId={bidder.id}
          tooltipName={bidder.dealership_name}
        >
          <Label ref={ref} onClick={bidder.is_bot ? undefined : handleOpen}>
            {label}
          </Label>
        </HoverInfoTooltip>
      )}
    </Wrapper>
  );
};
